var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCloseSmall(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8263 5.40441C14.1209 5.16414 14.5556 5.18158 14.8302 5.45617C15.1048 5.73077 15.1222 6.16551 14.882 6.46008L14.8302 6.51672L11.0607 10.2853L14.8292 14.0538L14.881 14.1114C15.121 14.406 15.1037 14.8399 14.8292 15.1144C14.5547 15.3889 14.1209 15.4062 13.8263 15.1661L13.7687 15.1144L10.0001 11.3458L6.23254 15.1144L6.17492 15.1661C5.88036 15.4062 5.44651 15.3889 5.17199 15.1144C4.89747 14.8399 4.88016 14.406 5.12023 14.1114L5.17199 14.0538L8.93957 10.2853L5.17102 6.51672L5.11926 6.46008C4.87895 6.1655 4.89641 5.73078 5.17102 5.45617C5.44562 5.18157 5.88034 5.1641 6.17492 5.40441L6.23156 5.45617L10.0001 9.22473L13.7696 5.45617L13.8263 5.40441Z",
    fill: "#676879"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseSmall);
export default __webpack_public_path__ + "static/media/close-small.a9e77492.svg";
export { ForwardRef as ReactComponent };